import { get as getStorage, set as setStorage } from 'idb-keyval'
import { trimSubscribedMod } from '@serializers/modConverter.js'
import { LS_SUBSCRIPTIONS } from '@config/localstorage.js'
import modSerializer from '@serializers/modSerializer.js'
import { computed, watch, ref } from 'vue'
import { clone } from '@helpers/utils.js'
import { GAME_ID } from '@config/game.js'

const subscriptionState = ref([])
const fetchedSubscriptions = ref(false)

async function init() {
  try {
    const state = await getStorage(LS_SUBSCRIPTIONS)
    if (state) {
      subscriptionState.value = state
    }
  } catch (error) {
    console.error(error)
  }
}

init()

watch(subscriptionState, (newState) => {
  setStorage(LS_SUBSCRIPTIONS, clone(newState))
})

export default function () {
  const subscriptions = computed(() =>
    subscriptionState.value.filter((m) => m.game_id === GAME_ID)
  )

  function clearSubscriptions() {
    subscriptionState.value = subscriptions.value.filter(
      (m) => m.game_id !== GAME_ID
    )
  }

  function setMySubscriptions(_subscriptions) {
    const data = modSerializer
      .transform({ data: _subscriptions })
      .data.map(trimSubscribedMod)

    const filtered = subscriptionState.value.filter(
      (m) => m.game_id !== GAME_ID
    )
    subscriptionState.value = [...filtered, ...data]

    return data
  }

  // use game and mod id
  function addSubscription(modId, modData) {
    if (!subscriptions.value.find((sub) => sub && sub.id === parseInt(modId))) {
      const transformedMod = modSerializer
        .transform({ data: [modData] })
        .data.map(trimSubscribedMod)[0]

      subscriptionState.value = [...subscriptions.value, transformedMod]
    }
  }

  // use game and mod id
  function removeSubscription(modId) {
    const updated = subscriptions.value.filter(
      (subscription) => subscription && subscription.id !== parseInt(modId)
    )

    subscriptionState.value = updated
  }

  function hasSubscriptionForUser(userNameId) {
    return computed(() =>
      subscriptions.value?.some(
        (mod) => mod.submitted_by.name_id === userNameId
      )
    )
  }

  return {
    hasSubscriptionForUser,
    fetchedSubscriptions,
    setMySubscriptions,
    clearSubscriptions,
    removeSubscription,
    addSubscription,
    subscriptions,
  }
}
